import { getUrlParams } from '@/utils/utils';
import { dicOption } from "@/option/config";
export default (() => {
  return {
    props: {
      click: Function,
      dataFormatter: Function | Object,
      titleFormatter: Function,
      labelFormatter: Function,
      clickFormatter: Function,
      formatter: Function,
      echartFormatter: Function,
      width: {
        type: [Number, String],
        default: 600
      },
      height: {
        type: [Number, String],
        default: 600
      },
      theme: {
        type: String
      },
      animation: {
        type: Boolean,
        default: true
      },
      child: {
        type: Object,
        default: () => {
          return {};
        }
      },
      time: {
        type: Number,
        default: 0
      },
      url: {
        type: String
      },
      disabled: {
        type: Boolean,
        default: true
      },
      dataType: {
        type: Number,
        default: 0
      },
      interfaceWay: {
        type: Number,
        default: 0
      },
      interfaceType: {
        type: String,
        default: ''
      },
      interfaceID: {
        type: String,
        default: ''
      },
      dataQuery: {
        type: Object,
        default: () => {
          return {};
        }
      },
      homeUrl: {
        type: String
      },
      dataAppend: {
        type: Boolean,
        default: false
      },
      dataMethod: {
        type: String,
        default: 'get'
      },
      id: {
        type: String,
        default: 'main_' + new Date().getTime()
      },
      data: {
        type: [Object, String, Array]
      },
      component: {
        type: Object,
        default: () => {
          return {};
        }
      },
      option: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    data() {
      return {
        propQuery: {},
        dataCount: 0,
        headerHeight: '',
        checkChart: '',
        myChart: '',
        dataChart: [],
        dataUrl: '',
        key: false,
        isChart: true,
        jobID: ''
      };
    },
    watch: {
      echartFormatter() {
        this.updateChart();
      },
      styleChartName() {
        this.$nextTick(() => {
          this.myChart && this.myChart.resize && this.myChart.resize();
        });
      },
      url: {
        handler(val) {
          this.dataUrl = val || '';
        },
        deep: true,
        immediate: true
      },
      data: {
        handler() {
          this.updateData();
        },
        deep: true,
        immediate: true
      },
      width() {
        this.updateData();
      },
      height() {
        this.updateData();
      },
      theme() {
        // 这三句一句都不能少
        this.myChart.dispose();
        this.init();
        this.updateData();
      },
      option: {
        handler() {
          if (this.myChart && this.isChart) {
            this.updateData();
          }
        },
        deep: true,
        immediate: true
      },
      interfaceID: {
        handler() {
          this.updateData();
        },
        deep: true,
        immediate: true
      },
    },
    computed: {
      dataChartLen() {
        return (this.dataChart || []).length;
      },
      switchTheme() {
        return this.vaildData(this.option.switchTheme, false);
      },
      name() {
        const result = this.$el.className.replace('avue-echart-', '');
        return result;
      },
      minWidth() {
        const val = this.option.minWidth;
        if (val > this.width) return val;

      },
      isApi() {
        return this.dataType === 1;
      },
      style() {
        return this.component.style || {};
      },
      styleChartName() {
        const obj = {
          width: this.setPx(this.minWidth || this.width),
          height: this.setPx(this.height)
        };
        return obj;
      },
      styleSizeName() {
        return Object.assign({
          width: this.setPx((this.width)),
          height: this.setPx((this.height))
        }, (() => {
          if (this.minWidth) {
            return {
              overflowX: 'auto',
              overflowY: 'hidden'
            };
          }
          return {};
        })());
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        // 判断是否引入echart包
        if (!window.echarts) {
          return;
        }
        const main = this.$refs[this.id];
        if (main) {
          // 判断是否图表去初始化
          this.isChart = dicOption.echart.includes(this.name);
          if (this.isChart) this.myChart = window.echarts.init(main, this.theme);
        }
      },
      updateUrl(url) {
        this.dataUrl = url;
        this.updateData();
      },
      // 更新数据核心方法
      updateData() {
        this.resetData && this.resetData();
        if (this.key) return;
        this.key = true;
        const callback = () => {
          this.key = false;
          // 动态数据
          if (this.isApi) {
            if (this.interfaceType === 'REDASH') {
              console.log()
              const backupData = this.replaceQuery();
              this.substep('/api/sophain-data-gateway/' + this.interfaceID, 'post', 'first', backupData) // 取得jobId
            } else {
              let result = getUrlParams(this.dataUrl);
              let url = result.url;
              let params = Object.assign(result.params, this.dataQuery, this.propQuery);
              this.requestFn(url, params)
            }
          } else {
            // 静态数据
            if (typeof this.dataFormatter === 'function') {
              this.dataChart = this.dataFormatter(this.data);
            } else {
              this.dataChart = this.data;
            }
            if (this.isChart && this.myChart) {
              this.myChart.clear();
              this.updateChart();
              this.bindClick();
            }
          }
        };
        this.$nextTick(() => {
          callback();
          clearInterval(this.checkChart);
          if (this.time !== 0 && this.disabled) {
            this.checkChart = setInterval(() => {
              callback();
            }, this.time);
          }
        });
      },
      replaceQuery() {
        const data = { ...this.dataQuery };
        for (let key in data) {
          if (data[key].indexOf('${') > -1) {
            const regex = /\{(.+?)\}/g;
            data[key].match(regex);
            const regexArr = RegExp.$1.split('?:');
            if (data[regexArr[0]]) {
              data[key] = data[regexArr[0]];
            } else {
              if (regexArr[1]) {
                data[key] = regexArr[1];
              } else {
                data[key] = ''
              }
            }
            delete data[regexArr[0]];
          }
        }
        return data;
      },
      substep(url, dataMethod, step, reqParams) {
        this.$store.commit('changeDataBack', false);
        this.$axios[dataMethod](url, reqParams).then(res => {
          if (step === 'first') {
            this.jobID = res.data.data.job.id
            this.substep('/api/sophain-data-gateway/job/' + this.jobID, 'get', 'second', {})// 需要循环多次-直到返回成功有id为止
          } else if (step === 'second') {
            if (res.data.data.job.query_result_id && res.data.data.job.query_result_id !== '') {
              this.substep('/api/sophain-data-gateway/result/' + res.data.data.job.query_result_id, 'get', 'third', {})// 取得最终结果渲染视图
            } else {
              this.substep('/api/sophain-data-gateway/job/' + this.jobID, 'get', 'second', {})// 需要循环多次-直到返回成功有id为止
            }
          } else if (step === 'third') {
            this.detail(res.data.data.query_result)
            this.$store.commit('changeDataBack', res.data.data.query_result);
          }
        });
      },
      requestFn(url, params) {
        this.$axios[this.dataMethod](url, (() => {
          if (this.dataMethod === 'get') {
            return {
              params: params
            };
          } else if (this.dataMethod === 'post') {
            return params;
          }
        })()).then(res => {
          this.detail(res);
        });
      },
      detail(res) {
        // 处理返回的数据
        const result = (() => {
          if (typeof this.dataFormatter === 'function') {
            return this.dataFormatter(res.data);
          }
          return res.data || {};
        })();
        // 延迟效果数据逐步增加
        if (this.dataAppend) {
          result.forEach(ele => {
            this.dataCount++;
            setTimeout(() => {
              this.dataChart.unshift(ele);
            }, this.dataCount * 1500);
          });
        } else {
          this.dataChart = result;
        }
        if (this.isChart && this.myChart) {
          this.myChart.clear();
          this.updateChart();
          this.bindClick();
        }
      },
      getLabelFormatter(name) {
        if (this.labelFormatter) {
          return this.labelFormatter(name, this.dataChart);
        }
        return name.value;
      },
      // 绑定点击事件
      bindClick() {
        try {
          this.myChart.on('click', e => {
            if (e.marker) {
              if (this.clickFormatter) {
                this.clickFormatter({
                  type: this.name,
                  name: e.name,
                  value: e.value[2] || e.value,
                  data: this.dataChart
                });
              }
            }
          });
        } catch (error) {
          //
        }
      },
      // 下面俩都是chart的公共的方法,就放这里面共用
      getColor(index, first) {
        const barColor = this.option.barColor || [];
        if (barColor[index]) {
          const color1 = barColor[index].color1;
          const color2 = barColor[index].color2;
          const postion = (barColor[index].postion || 0.9) * 0.01;
          if (first) return color1;
          if (color2) {
            return {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0,
                color: color1 // 0% 处的颜色
              }, {
                offset: postion,
                color: color2 // 100% 处的颜色
              }],
              global: false // 缺省为 false
            };
          }
          return color1;
        }
      },
      ishasprop(condition, isprop, alwaysObj) {
        return Object.assign((() => {
          return condition ? isprop : {};
        })(), alwaysObj);
      }
    }
  };
})();